// Configuración en runtime (patrón env.json de his-frontend-core adaptado a CRA).
//
// La imagen Docker es env-agnóstica: los valores por-ambiente se inyectan al
// arrancar el container (entrypoint → envsubst genera /env.js) y el navegador
// los expone en `window._env_` antes de cargar el bundle (ver public/index.html).
//
// Precedencia: window._env_ (runtime) → process.env.REACT_APP_* (build, dev local)
// → fallback. Así `npm start` en local sigue funcionando con el .env de siempre,
// y en producción manda Infisical vía runtime. Preserva el promote misma-imagen
// UAT→prod de Auto-CD (no se hornea ningún valor de ambiente en la imagen).
const runtime = (typeof window !== 'undefined' && window._env_) || {};

const get = (key, fallback = '') => {
  const rt = runtime[key];
  if (rt !== undefined && rt !== null && rt !== '' && rt !== `\${REACT_APP_${key}}`) {
    return rt;
  }
  const build = process.env[`REACT_APP_${key}`];
  return build !== undefined && build !== null && build !== '' ? build : fallback;
};

const config = {
  API_URL: get('API_URL'),
  ROUTER_NAME: get('ROUTER_NAME'),
  ID_CLINICA: get('ID_CLINICA'),
  PAQUETE_GENERICO_ID: get('PAQUETE_GENERICO_ID'),
  PAQUETE_GENERICO_NAME: get('PAQUETE_GENERICO_NAME'),
  SELECT_PROGRAMADA: get('SELECT_PROGRAMADA'),
  SELECT_URGENCIAS: get('SELECT_URGENCIAS'),
  SELECT_AMBULATORIA: get('SELECT_AMBULATORIA'),
};

export default config;
